import { TFunction } from 'i18next'

export type StandardPluralKey = 'credit' | 'character'
export type StandardPluralCategory = 'zero' | 'one' | 'few' | 'many' | 'other'

const normalizePluralCategory = (
  category: Intl.LDMLPluralRule
): StandardPluralCategory => {
  if (category === 'one') return 'one'
  if (category === 'few') return 'few'
  if (category === 'many') return 'many'
  return 'other'
}

export const getStandardPluralCategory = (
  language: string,
  count: number
): StandardPluralCategory => {
  if (count === 0) return 'zero'
  return normalizePluralCategory(new Intl.PluralRules(language).select(count))
}

export const getStandardPluralLabel = (
  t: TFunction,
  language: string,
  key: StandardPluralKey,
  count: number
): string => {
  const category = getStandardPluralCategory(language, count)
  return t(`plurals.${key}.${category}`, { ns: 'common', count })
}

export const formatStandardPlural = (
  t: TFunction,
  language: string,
  key: StandardPluralKey,
  count: number
): string => `${count} ${getStandardPluralLabel(t, language, key, count)}`
